import { motion } from 'framer-motion';
import React from 'react';
import { LAYOUT_SPRING, OPACITY_FADE } from './animationConfig';

interface AnimatedListItemProps {
  itemKey: string;
  children: React.ReactNode;
}

export const AnimatedListItem: React.FC<AnimatedListItemProps> = ({
  itemKey,
  children,
}) => (
  <motion.div
    key={itemKey}
    layout='position'
    layoutDependency={itemKey}
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ layout: LAYOUT_SPRING, opacity: OPACITY_FADE }}
    style={{ willChange: 'transform' }}
  >
    {children}
  </motion.div>
);
